<lottie-animation-view
                    [options]="lottieConfig"
                    (animCreated)="handleAnimation($event)">
              </lottie-animation-view>
<!-- <div style="width: 100%; height: 100%;    width: 100%;
height: 100%;
display: flex;
flex-direction: column;
align-content: center;
align-items: center;
justify-content: space-around;
background-image: url('../../../assets/images/mantencio.png')">
      <div style="width: max-content;
      height: 310px;
      background: cadetblue;
      border-radius: 51px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      align-content: space-around;
      justify-content: center;
      flex-direction: column;
      opacity: 0.9;">
            <p style="    font-size: 30px;
            color: red;
            font-weight: 800;
            opacity: 1;
            margin: 10px;">El sitio web se encuentra en mantención.</p>

            <p style="font-size: 20px;
            font-weight: 700;
            opacity: 1">Cualquier consulta comunicarse al fono 224327736.</p>
      </div>
</div> -->